import { VFC } from 'react'
import { Link } from 'src/elements/Link'
import {
  black,
  truewhite,
  _profilegreen,
  _profilehrborder,
} from 'src/styles/colors'
import { fontWeightBold, fontWeightSemiBold } from 'src/styles/font'
import styled from 'styled-components'
import { CustomLinkify } from '../Linkify'
import { CompanyItem, Section, sectionBodyStyle } from './styles'
import { ProfilePreviewProps } from './types'

export const CompanySection: VFC<ProfilePreviewProps> = ({
  user: {
    company: {
      prefecture,
      foundedOn,
      numberOfEmployees,
      capital,
      businessType,
      businessObject,
      serviceDescription,
      storyUrl,
      hpUrl,
      fbUrl,
      isListed,
    },
  },
}) => {
  const hasCompanyInfo = prefecture || foundedOn || numberOfEmployees || capital
  const hasBusiness = businessType || businessObject
  const hasHp = hpUrl
  if (!(hasCompanyInfo || hasBusiness || serviceDescription || hasHp))
    return <></>
  return (
    <Section>
      <h3>企業情報・事業内容</h3>
      <CompanyDiv>
        {hasCompanyInfo && (
          <>
            <h4>企業情報</h4>
            {prefecture && <CompanyItem>所在地： {prefecture}</CompanyItem>}
            {foundedOn && (
              <CompanyItem>
                設立年数： {new Date().getFullYear() - +foundedOn}年
              </CompanyItem>
            )}
            {numberOfEmployees && (
              <CompanyItem>従業員数： {numberOfEmployees}</CompanyItem>
            )}
            {capital && <CompanyItem>資本金： {capital}</CompanyItem>}
            {isListed != null && (
              <CompanyItem>
                上場区分： {isListed ? '上場' : '未上場'}
              </CompanyItem>
            )}
          </>
        )}
        {hasBusiness && (
          <>
            <h4>業種</h4>
            <BusinessItems>
              {businessType && <BusinessItem>{businessType}</BusinessItem>}
              {businessObject && (
                <BusinessItem>商材： {businessObject}</BusinessItem>
              )}
            </BusinessItems>
          </>
        )}
        {serviceDescription && (
          <>
            <h4>事業・サービス紹介</h4>
            <CustomLinkify>{serviceDescription}</CustomLinkify>
          </>
        )}
      </CompanyDiv>
      <ButtonDiv>
        {storyUrl && (
          <ProfileLink href={storyUrl} target="_blank">
            インタビュー記事
          </ProfileLink>
        )}
        {hpUrl && (
          <ProfileLink href={hpUrl} target="_blank">
            HPを見る
          </ProfileLink>
        )}
        {fbUrl && (
          <FacebookLink href={fbUrl} target="_blank">
            Facebookを見る
          </FacebookLink>
        )}
      </ButtonDiv>
    </Section>
  )
}

const CompanyDiv = styled.div`
  ${sectionBodyStyle};
  h4 {
    margin-top: 28px;
    padding-bottom: 12px;
    color: ${_profilegreen};
    font-size: 14px;
    font-weight: ${fontWeightSemiBold};
    letter-spacing: 0.05em;
    border-bottom: 2px solid ${_profilehrborder};
    :first-child {
      margin-top: 0;
    }
  }
`

const ButtonDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 680px;
  margin: 0 auto;
  justify-content: space-evenly;
`

const ProfileLink = styled(Link)`
  min-width: 200px;
  border: 1px solid;
  padding: 14px 0;
  border-radius: 5px;

  background: ${truewhite};
  font-size: 14px;
  font-weight: ${fontWeightBold};
  text-align: center;
  :hover {
    color: ${truewhite};
    background-color: ${black};
  }
`

const FacebookLink = styled(Link)`
  min-width: 200px;
  border: 1px solid;
  padding: 14px 0;
  border-radius: 5px;

  color: #0084ff;
  background: ${truewhite};
  font-size: 14px;
  font-weight: ${fontWeightBold};
  text-align: center;
  :hover {
    color: ${truewhite};
    background-color: #0084ff;
  }
`

export const BusinessItems = styled.p`
  padding-top: 10px;
`

export const BusinessItem = styled.p`
  padding: 2px 0;
`
